<template>
  <div class="dialog_box">
    <el-dialog title="反馈转工单" :visible="show" width="800px" @close="dialogClose" top="10vh" :close-on-click-modal="false">
      <div class="dialog_container">
        <el-form ref="form" class="form_box" :model="form" label-width="110px" :rules="rules">
          <div class="module_box">
            <div class="form_title">基本信息</div>
            <el-form-item label="企业名称" prop="orgId">
              <el-select v-model="form.orgId" filterable placeholder="请输入/选择企业名称" @change="orgChange">
                <el-option v-for="item in orgList" :key="item.id" :label="item.orgName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工单类型" prop="orderType">
              <el-select v-model="form.orderType" @change="selectChange" placeholder="请选择工单类型">
                <el-option v-for="item in orderTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系人" prop="contactsName">
              <el-input v-model="form.contactsName" placeholder="请输入联系人"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" prop="contactsPhone">
              <el-input v-model="form.contactsPhone" placeholder="请输入联系方式"></el-input>
            </el-form-item>
            <el-form-item label="联系邮箱">
              <el-input v-model="form.contactsEmail" placeholder="请输入联系邮箱"></el-input>
            </el-form-item>
            <el-form-item label="所属区域">
              <el-cascader v-model="form.addrId" :options="areaTree" :props="optionProps" :filterable="true"
                :emitPath="false" :show-all-levels="true" @change="cascaderChange" ref="cascader"></el-cascader>
            </el-form-item>
            <el-form-item label="详细地址" prop="addrDetail">
              <el-input v-model="form.addrDetail" placeholder="请输入详细地址"></el-input>
            </el-form-item>
            <el-form-item label-width="0">
              <div class="map_box">
                <div class="map_btn">定位</div>
                <div class="map_img" @click="mapShow = true">
                  <el-amap :center="center" :zoom="zoom" :dragEnable="false" :zoomEnable="false" defaultCursor="default">
                    <el-amap-marker v-for="(marker, index) in markers" :position="marker.position" :events="marker.events"
                      :visible="marker.visible" :draggable="marker.draggable" :vid="index" :key="index"></el-amap-marker>
                  </el-amap>
                </div>
              </div>
            </el-form-item>
          </div>

          <div class="module_box" v-if="form.orderType == '2' || form.orderType == '3' || form.orderType == '4'">
            <div class="form_title">网点信息</div>
            <el-form-item label="业务属性" prop="netAttr">
              <el-select v-model="form.netAttr" placeholder="请选择业务属性">
                <el-option v-for="item in netAttrList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通道数量">
              <el-input v-model="form.netCameraNum" placeholder="请输入通道数量"></el-input>
            </el-form-item>
            <el-form-item label="设备品牌">
              <el-select v-model="form.netCameraBrand" placeholder="请选择设备品牌">
                <el-option v-for="item in netCameraList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="网点名称">
              <el-input v-model="form.netName" placeholder="请输入网点名称"></el-input>
            </el-form-item>
            <el-form-item label="站点名称">
              <el-input v-model="form.netSiteName" placeholder="请输入站点名称"></el-input>
            </el-form-item>
            <el-form-item label="期望上门/处理时间" label-width="160px" class="timeform">
              <el-date-picker v-model="form.orderExpectDoorTime" type="datetime" placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="form.orderRemark" type="textarea" placeholder="请输入备注"></el-input>
            </el-form-item>
          </div>

          <div class="module_box" v-else>
            <div class="form_title">安装/维护车辆</div>
            <el-form-item label="车牌号码" prop="carNumber">
              <el-input v-model="form.carNumber" placeholder="请输入车牌号码"></el-input>
            </el-form-item>
            <el-form-item label="通道数量">
              <el-input v-model="form.carCameraNum" placeholder="请输入通道数量"></el-input>
            </el-form-item>
            <el-form-item label="设备品牌">
              <el-select v-model="form.carCameraBrand" placeholder="请选择设备品牌">
                <el-option v-for="item in netCameraList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车辆数量">
              <el-input v-model="form.carNum" placeholder="请输入车辆数量"></el-input>
            </el-form-item>
            <el-form-item label="设备序列号">
              <el-input v-model="form.carSerialNumber" placeholder="请输入设备序列号"></el-input>
            </el-form-item>
            <el-form-item label="期望上门/处理时间" label-width="160px" class="timeform">
              <el-date-picker v-model="form.orderExpectDoorTime" type="datetime" placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="form.orderRemark" type="textarea" placeholder="请输入备注"></el-input>
            </el-form-item>
          </div>

          <div class="module_box">
            <div class="form_title">指派信息</div>
            <el-form-item label="审批人员" prop="auditUser">
              <el-select v-model="form.auditUser" placeholder="请选择审批人员">
                <el-option v-for="item in auditUserList" :key="item.userId" :label="item.username"
                  :value="item.userId"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('form')">提 交</el-button>
      </span>
    </el-dialog>

    <v-map :show.sync="mapShow" @mapParams="mapChange($event)" :center="center"></v-map>
  </div>
</template>

<script>
import map from "@/components/map.vue";
import axios from "axios";
export default {
  name: "",
  data () {
    return {
      form: {
        addr: "",
        addrDetail: "",
        auditUser: "",
        carCameraBrand: "",
        carCameraNum: null,
        carNum: null,
        carNumber: "",
        carSerialNumber: "",
        contactsEmail: "",
        contactsName: "",
        contactsPhone: "",
        lat: "",
        lng: "",
        netAttr: "",
        netCameraBrand: "",
        netCameraNum: null,
        netName: "",
        netSiteName: "",
        orderType: null,
        orgName: "",
        orgId: null,
        addrId: null
      },
      netAttrList: [
        {
          name: "分端机构",
          id: "分端机构",
        },
        {
          name: "末端网点",
          id: "末端网点",
        },
      ],
      netCameraList: [
        {
          name: "大华",
          id: "大华",
        },
        {
          name: "海康",
          id: "海康",
        },
        {
          name: "其它",
          id: "其它",
        },
      ],
      rules: {
        orgName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        orderType: [
          { required: true, message: "请选择工单类型", trigger: "change" },
        ],
        contactsName: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        contactsPhone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
        ],
        contactsEmail: [
          { required: true, message: "请输入联系邮箱", trigger: "blur" },
        ],
        netAttr: [
          { required: true, message: "请选择业务属性", trigger: "change" },
        ],
        addrDetail: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: ["blur", "change"],
          },
        ],
        carCameraNum: [
          { required: true, message: "请输入通道数量", trigger: "blur" },
        ],
        carNum: [
          { required: true, message: "请输入车辆数量", trigger: "blur" },
        ],
        carSerialNumber: [
          { required: true, message: "请输入设备序列号", trigger: "blur" },
        ],
        carNumber: [
          { required: true, message: "请输入车牌号码", trigger: "blur" },
        ],
        netCameraNum: [
          { required: true, message: "请输入通道数量", trigger: "blur" },
        ],
        netName: [
          { required: true, message: "请输入网点名称", trigger: "blur" },
        ],
        netSiteName: [
          { required: true, message: "请输入站点名称", trigger: "blur" },
        ],
        auditUser: [
          { required: true, message: "请选择审批人员", trigger: "change" },
        ],
        addrId: [
          { required: true, message: "请选择所在区域", trigger: "change" },
        ],
      },
      orderTypeList: [],
      auditUserList: [],
      areaTree: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
      },
      mapShow: false,
      center: [116.397425, 39.909287],
      markers: [
        {
          position: [116.397425, 39.909287],
          events: {},
          visible: true,
          draggable: false,
          template: "<span>1</span>",
        },
      ],
      zoom: 12,
      orgList: []
    };
  },
  components: {
    "v-map": map,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {}
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.form = {
          orderType: this.data.orderType + '',
          contactsPhone: this.data.contactsPhone,
          addrDetail: this.data.addrDetail,
          contactsName: this.data.contactsName
        }
        this.$http.queryLeaderList().then((res) => {
          if (res.code === 0) {
            this.auditUserList = res.data;
          } else {
            this.auditUserList = [];
          }
        });
        this.$http.queryDist({ type: "工单类型" }).then((res) => {
          if (res.code === 0) {
            this.orderTypeList = res.data;
          } else {
            this.orderTypeList = [];
          }
        });
        this.$http.areaTree({ isTree: true }).then((res) => {
          if (res.code === 0) {
            this.areaTree = res.data;
          } else {
            this.areaTree = [];
          }
        });
        this.$http.queryOrgList({ page: 1, limit: 999999 }).then(res => {
          if (res.code === 0) {
            this.orgList = res.data;
          } else {
            this.orgList = [];
          }
        })
      }
    },
  },
  created () { },
  methods: {
    orgChange (e) {
      this.orgList.forEach(i => {
        if (i.id === e) {
          this.form.orgName = i.orgName
        }
      })
    },
    cascaderChange (value) {
      let name1 = "";
      let name2 = "";
      let name3 = "";
      this.areaTree.forEach((a) => {
        if (a.children && a.children.length > 0) {
          a.children.forEach((b) => {
            if (b.children && b.children.length > 0) {
              b.children.forEach((c) => {
                if (c.id == value) {
                  name3 = c.name;
                  if (c.parentId == b.id) {
                    name2 = b.name;
                    if (b.parentId == a.id) {
                      name1 = a.name;
                    }
                  }
                }
              });
            }
          });
        }
      });
      this.form.addressDetail = "";
      const url = "https://restapi.amap.com/v3/geocode/geo";
      let address = name1 + name2 + name3;
      this.form.addr = address;
      axios
        .get(url, {
          params: {
            address: address,
            key: "5b53822df7d7324e6306268237692ba6",
          },
        })
        .then((item) => {
          this.center = this.markers[0].position =
            item.data.geocodes[0].location.split(",");
          // this.center = this.markers[0].position
          // console.log("---",item.data.geocodes[0].location.split(","));
          this.form.lng = this.center[0];
          this.form.lat = this.center[1];
        });
    },
    selectChange () {
      this.$set(this.form, "carNumber", "");
      this.$set(this.form, "carCameraNum", "");
      this.$set(this.form, "carCameraBrand", "");
      this.$set(this.form, "carNum", "");
      this.$set(this.form, "carSerialNumber", "");
      this.$set(this.form, "netAttr", "");
      this.$set(this.form, "netCameraNum", "");
      this.$set(this.form, "netCameraBrand", "");
      this.$set(this.form, "netName", "");
      this.$set(this.form, "netSiteName", "");
      this.$set(this.form, "orderExpectDoorTime", "");
      this.$set(this.form, "orderRemark", "");
    },
    dialogClose () {
      this.form = {
        addr: "",
        addrDetail: "",
        auditUser: "",
        carCameraBrand: "",
        carCameraNum: null,
        carNum: null,
        carNumber: "",
        carSerialNumber: "",
        contactsEmail: "",
        contactsName: "",
        contactsPhone: "",
        lat: "",
        lng: "",
        netAttr: "",
        netCameraBrand: "",
        netCameraNum: null,
        netName: "",
        netSiteName: "",
        orderType: null,
        orgName: "",
        addrId: null,
        addressDetail: ""
      };
      this.center = [116.397425, 39.909287];
      (this.markers = [
        {
          position: [116.397425, 39.909287],
          events: {},
          visible: true,
          draggable: false,
          template: "<span>1</span>",
        },
      ]),
        this.$emit("update:show", false);
    },
    confirm (formName) {
      console.log(this.form.carCameraBrand);
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        // if (this.type === 0) {
        this.$http.addWorkOrder(this.form).then((res) => {
          if (res.code === 0) {
            // this.$message.success(res.msg);
            this.form = {};
            this.$parent.getList();
            this.$emit("update:show", false);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    mapChange (val) {
      console.log("子传父", val);
      this.form.lat = val.lat;
      this.form.lng = val.lng;
      this.form.addrDetail = val.addressDetail;
      this.center = this.markers[0].position = [val.lng, val.lat];
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";

.map_box {
  width: 350px;
  height: 53px;
  display: flex;
  justify-content: space-between;

  .map_btn {
    cursor: pointer;
    background-color: #255a7e;
    width: 53px;
    height: 28px;
    display: flex;
    border-radius: 5px;
    font-size: 16px;
    justify-content: center;
    align-items: center;
    color: #fff;
  }

  .map_img {
    width: 290px;
    height: 90px;
  }
}

.timeform {
  /deep/.el-input {
    width: 190px !important;

    .el-input__inner {
      width: 190px !important;
      padding-right: 0;
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/views/feedback/component/add.vue